module.exports = __webpack_public_path__ + "img/tip3.6ad55cec.png";